export const importedInvestmentWaringText =
  "Information about investments that have been imported from another system may be incomplete if only partial historical data has been imported.";
